import { useState } from "react";
import NoSchedule from "./NoSchedule";
import EditInterest from "./EditInterest";
import ViewInterest from "./ViewInterest";
import { useEffect } from "react";
import LoaderComp from "../../components/LoaderComp";
import { useParams } from "react-router-dom";
import axios from "../../axios/axios";
import { useContext } from "react";
import { InterestRateContext } from ".";

const ScheduleRateTab = (props) => {
    const {itemIdx} = props;
    const {productData,isFetching} = useContext(InterestRateContext);
    let scheduleData = productData.interests[itemIdx];
    const [editOption,setEditOption]=useState(true);
    const [noSched,setnoSched]=useState(true);
    const [compLoad,setCompLoad] = useState(true);

    console.log(scheduleData.agentbonusinfo)

    const scheduleSave = () => {
      setEditOption(!editOption);
      props.InterestTabTop();
    }

    const editHandle = () => {
      setEditOption(true);
      props.InterestTabTop();
    }

    const fallBack = () => {
      setnoSched(true);
      props.InterestTabTop();
    }
  
    useEffect(()=>{
      if(scheduleData.agentbonusinfo){
        if(scheduleData.agentbonusinfo.schedule){
          setnoSched(false);
          setEditOption(false);
        }
      }
      setTimeout(()=>{
        setCompLoad(false);
      },500)
    },[])
  return (
    <>
      {
        (!isFetching && !compLoad) ?
        <div>
              {
                noSched ?
                <NoSchedule haveInterestBonus={scheduleData.agentbonusinfo} changeToCurrent={()=>props.changeToCurrent()} editOpt={()=>setnoSched(false)} />
                :
                <>
                  {editOption ? <EditInterest scheduleSave={scheduleSave} fallBack={fallBack} product={scheduleData} schedule /> :
                  <ViewInterest itemIdx={itemIdx} schedule editHandle={editHandle} />
                  }
                </>
              }
        </div>
        : <LoaderComp />
      }
    </>
  )
};

export default ScheduleRateTab;
